import { Action as ReduxAction } from 'redux';

import { BackgroundJobAllowedActions } from '~src/backgroundJob/types/BackgroundJobAllowedActions';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { IDataRoleActions } from '~src/dataRole/serverApi/types/IDataRoleActions';
import { IDatasourceActions } from '~src/datasource/ServerApi/types/IDatasourceActions';
import { FlowAllowedActions } from '~src/flow/serverApi/types/FlowAllowedActions';
import { IProjectActions } from '~src/projects/ServerApi/types/IProjectActions';
import { ResourceGovernanceAllowedActions } from '~src/schedule/types/ResourceGovernanceService';
import { IViewActions } from '~src/views/ServerApi/types/IViewActions';
import { IWorkbookActions } from '~src/workbook/ServerApi/types/IWorkbookActions';


export enum EntityActionNames {
  AccelerateWorkbook = 'AccelerateWorkbook',
  AcknowledgeUserIdentityConflict = 'AcknowledgeUserIdentityConflict',
  ActivateSite = 'activate-site',
  AddToCollections = 'add-to-collections',
  AuthorConfiguredDCROff = 'AuthorConfiguredDCROff',
  AuthorConfiguredDCROn = 'AuthorConfiguredDCROn',
  AuthorConfiguredDCRSubmenu = 'AuthorConfiguredDCRSubmenu',
  CancelBackgroundJob = 'cancelBackgroundJob',
  ChangeExtractDsToLive = 'change_extract_ds_to_live',
  ChangeExtractDsToLiveEmb = 'change_extract_ds_to_live_emb',
  TasksChangeSchedule = 'tasks-change-schedule',
  TasksEdit = 'tasks-edit',
  TasksEditExpectedDuration = 'tasks-edit-expected-duration',
  SubscriptionChangeDataSetting = 'subscription-change-data-setting',
  TasksChangeSubject = 'tasks-change-subject',
  SubscriptionChangeFormat = 'subscription-change-format',
  SubscriptionChangeFrequency = 'subscription-change-frequency',
  CollectionDetails = 'collection-details',
  ConnectedApplicationDetails = 'connected-application-details',
  ConnectedApplicationToggleEnablement = 'connected-application-toggle-enablement',
  CreateExtractsEncrypted = 'create_extracts_encrypted',
  CreateExtractsUnencrypted = 'create_extracts_unencrypted',
  CreateExtracts = 'create_extracts',
  CreateExtractsEmbEncrypted = 'create_extracts_emb_encrypted',
  CreateExtractsEmbUnencrypted = 'create_extracts_emb_unencrypted',
  CreateExtractsEmb = 'create_extracts_emb',
  CreateFlowSubscription = 'create_flow_subscription',
  AddSelf = 'addSelf',
  Edit = 'edit',
  EditDatasource = 'edit_datasource',
  RemoveSelf = 'removeSelf',
  Resume = 'resume',
  Decrypt = 'decrypt',
  Delete = 'delete',
  DisableWorkbookAcceleration = 'disableWorkbookAcceleration',
  TasksDelete = 'tasks-delete',
  DiscardDraft = 'discard-draft',
  Download = 'download',
  Move = 'move',
  NewFlow = 'new_flow',
  NewLens = 'new_lens',
  NewMetric = 'new_metric',
  NewPredictiveModel = 'new_predictive_model',
  NewWorkbook = 'new_workbook',
  RefreshExtracts = 'refresh_extracts',
  RemoveExternalContent = 'removeExternalContent',
  RemoveFromThisCollection = 'remove-from-this-collection',
  Rename = 'rename',
  TasksResumeExtractRefresh = 'tasks-resume-extract-refresh',
  SubscriptionResume = 'subscription-resume',
  RevisionHistory = 'revision_history',
  TasksRunNow = 'tasks-run-now',
  RunNow = 'runNow',
  TasksPriority = 'tasks-priority',
  TasksResume = 'tasks-resume',
  DisableSchedules = 'disableSchedules',
  EditSchedule = 'edit-schedule',
  EnableSchedules = 'enableSchedules',
  ScheduleFlowTaskSubmenu = 'ScheduleFlowTaskSubmenu',
  ScheduleLinkedTask = 'ScheduleLinkedTask',
  ScheduleSingleFlowTask = 'ScheduleSingleFlowTask',
  SchedulesRunNow = 'schedules-run-now',
  SetCertification = 'setCertification',
  SetSensitiveDataLabel = 'setSensitiveDataLabel',
  SetContact = 'setContact',
  DataQualityMenu = 'dataQualityMenu',
  SetDataQuality = 'setDataQuality',
  SetDataQualityTrigger = 'setDataQualityTrigger',
  DataQualitySubmenu = 'dataQualitySubmenu',
  SetDescription = 'setDescription',
  SetDisplayTabs = 'setDisplayTabs',
  SetOwner = 'setOwner',
  Permissions = 'permissions',
  SetTags = 'setTags',
  ShareContent = 'shareContent',
  SuspendSite = 'suspend-site',
  UnsubscribeSubscriptions = 'unsubscribe-subscriptions',
  WhoHasSeenThisView = 'who_has_seen_this_view',
  EditDataConnection = 'edit_data_connection',
  EditFlow = 'editFlow',
  EditPredictiveModel = 'editPredictiveModel',
  EditPublishedConnection = 'editPublishedConnection',
  PublishedConnectionTableExtractsRefreshNow = 'PublishedConnectionTableExtractsRefreshNow',
  EditSiteSettings = 'edit-site-settings',
  Encrypt = 'encrypt',
  ExtractsEncrptionEncrypted = 'extracts_encrption_encrypted',
  ExtractsEncrptionUnencrypted = 'extracts_encrption_unencrypted',
  ExtractsEncrptionAction = 'extracts_encrption_action',
  HideRecommendation = 'hideRecommendation',
  SiteUserSiteRole = 'siteuser-siteRole',
  SiteUserRemove = 'siteuser-remove',
  SiteUserRemoveFromGroup = 'siteuser-remove-group',
  SiteUserEditGroupMembership = 'siteuser-groupMembership',
  SiteUserAuthentication = 'siteuser-authentication',
  SiteUserForcePasswordReset = 'siteuser-forcePasswordUpdate',
  SiteUserResetLoginRateLimiting = 'siteuser-resetLoginRateLimiting',
  SiteUserAddToIdentityPool = 'SiteUserAddToIdentityPool',
  SiteUserRemoveFromIdentityPool = 'SiteUserRemoveFromIdentityPool',
  ServerUserDeleteUsers = 'serveruser-delete',
  ServerUserEditSiteMembership = 'serveruser-siteMembership',
  ServerUserForcePasswordReset = 'serveruser-forcePasswordUpdate',
  ServerUserResetLoginRateLimiting = 'serveruser-resetLoginRateLimiting',
  ServerUserAddToIdentityPool = 'ServerUserAddToIdentityPool',
  ServerUserRemoveFromIdentityPool = 'ServerUserRemoveFromIdentityPool',
  SynchronizeGroup = 'sync-group',
  SynchronizeGroups = 'sync-groups',
  UpdateGroupMinimumSiteRole = 'update-group-site-role',
  UpdateGroupGrantLicenseMode = 'update-group-grant-license-mode',
  DeleteGroup = 'delete-group',
  GroupDatabases = 'group-databases',
  UngroupDatabases = 'ungroup-databases',
  ScheduleRefreshWithBridge = 'schedule-refresh-with-bridge',
  OpenWorkbookInDesktop = 'open-workbook-in-desktop',
  Share = 'share',
  EnableLinkedTask = 'enable-linked-tasks',
  DisableLinkedTask = 'disable-linked-tasks',
  DataAccelerationSubmenu = 'DataAccelerationSubmenu',
  AdminAllowDataAcceleration = 'AdminAllowDataAcceleration',
  AdminDisallowDataAcceleration = 'AdminDisallowDataAcceleration',
  DataAccelerationOn = 'DataAccelerationOn',
  DataAccelerationOff = 'DataAccelerationOff',
  UpdateDataFreshnessPolicy = 'UpdateDataFreshnessPolicy',
  ReevaluateUserIdentityConflict = 'ReevaluateUserIdentityConflict',
  ResourceGovernanceResetSiteToDefaultsAction = 'resourceGovernanceResetSiteToDefaultsAction',
  ResourceGovernanceEditSiteAction = 'resourceGovernanceEditSiteAction',
  RetryUserIdentityMigration = 'RetryUserIdentityMigration',
  ResolveAmbiguousUserIdentityConflict = 'ResolveAmbiguousUserIdentityConflict',
  PublishToSalesforce = 'PublishToSalesforce',
}

/**
 * An action that can be performed on an entity (content item, user, group, subscription, etc.).
 */
export interface IEntityAction<TItem, TAvailableActions> {
  name: EntityActionNames;
  parentName?: string;
  translateName(targetItems?: TItem[], state?: AppState): string; // A `Messages` function
  isVisible(targetItems: TItem[], state: AppState, availableActions?: TAvailableActions|undefined): boolean;
  isClickable(availableActions: TAvailableActions|undefined, targetItems: TItem[], state: AppState): boolean;
  createReduxAction(targetItems: TItem[]): ReduxAction;
  isChecked?: (availableActions: TAvailableActions, targetItems: TItem[], state: AppState) => boolean;
}


export type AvailableActionsForAllContentTypes =
  IWorkbookActions &
  IDatasourceActions &
  IProjectActions &
  IDataRoleActions &
  IViewActions &
  FlowAllowedActions &
  BackgroundJobAllowedActions &
  ResourceGovernanceAllowedActions;

// Until we implement story 752767, which will check for permissions on actions of multiple content
// types, we're pretending the user has permission for all actions, so we pass this object into
// the entity actions, instead of the actual available actions from the server for a particular entity.
export const AllActionsAllowed: { readonly [K in keyof AvailableActionsForAllContentTypes]: true } = {
  addComment: true,
  cancelBackgroundJob: true,
  createProject: true,
  decryptExtracts: true,
  del: true,
  download: true,
  encryptExtracts: true,
  launchWebAuthoring: true,
  manageFlow: true,
  publishToSalesforce: true,
  refreshExtract: true,
  runFlow: true,
  seeComments: true,
  setConnection: true,
  setCertification: true,
  setDescription: true,
  setDisplayTabs: true,
  setName: true,
  setOwner: true,
  setPermissions: true,
  setProject: true,
  setTags: true,
  showNlp: true,
  versionManagement: true,
  updateRemoveDataQuality: true,
  sendEmail: true,
  createExtracts: true,
  extractsToLive: true,
  webEditFlow: true,
  share: true,
  whoHasSeenThisView: true,
  editDatasource: true,
  editAllowedPublishedDatasource: true,
  enableAcceleration: true,
  disableAcceleration: true,
  editDataFreshnessPolicy: true,
  createPredictiveModel: true,
  createSubscription: true,
  editResourceGovernanceSite: true,
  resetSiteResourceGovernanceSite: true,
  turnAuthorConfiguredDCROn: true,
  turnAuthorConfiguredDCROff: true
};
